import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Check } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ProUpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  limitType: "clients" | "loans";
}

export function ProUpgradeModal({ open, onOpenChange, limitType }: ProUpgradeModalProps) {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onOpenChange(false);
    navigate("/subscription");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md glass-strong">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 shadow-lg">
              <Crown className="h-8 w-8 text-white" />
            </div>
          </div>
          <DialogTitle className="text-center text-xl">
            Limite do Plano Gratuito Atingido
          </DialogTitle>
          <DialogDescription className="text-center">
            Você atingiu o limite máximo de {limitType === "clients" ? "10 clientes" : "10 empréstimos"} do plano gratuito.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="glass p-4 rounded-lg space-y-3">
            <h4 className="font-semibold text-foreground flex items-center gap-2">
              <Crown className="h-4 w-4 text-amber-500" />
              Benefícios do Plano PRO
            </h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-center gap-2">
                <Check className="h-4 w-4 text-green-500" />
                Clientes ilimitados
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-4 w-4 text-green-500" />
                Empréstimos ilimitados
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-4 w-4 text-green-500" />
                Dashboard analítico completo
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-4 w-4 text-green-500" />
                Relatórios avançados
              </li>
              <li className="flex items-center gap-2">
                <Check className="h-4 w-4 text-green-500" />
                Suporte prioritário
              </li>
            </ul>
          </div>

          <div className="text-center">
            <p className="text-2xl font-bold text-foreground">
              R$ 29,90<span className="text-sm font-normal text-muted-foreground">/mês</span>
            </p>
          </div>
        </div>

        <div className="flex gap-3">
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)} 
            className="flex-1"
          >
            Voltar
          </Button>
          <Button 
            onClick={handleUpgrade} 
            className="flex-1 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white"
          >
            Assinar PRO
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
